import { isCookieBannerEnabled, MARK, SELECTOR } from "./helper";
import { trackEmptyState } from "./tracking/EmptyState";
import type { SuggestResponse } from "./types/suggestion";
/*🤫*/
/*🤫*/
import templateString from "../public/templates/emptyStateLayer.mustache";
import { headlineTemplate, keywordsTemplate } from "./templates/emptyState.templates";
import { HistorySearchItem } from "./types/suggestion";

const Mustache = window.Mustache;

export class EmptyStateSuggest {
  private suggestLayer: HTMLDivElement;
  private searchField: HTMLInputElement;
  private searchForm: HTMLFormElement;

  constructor() {
    this.suggestLayer = document.querySelector(SELECTOR.LAYER) as HTMLDivElement;
    this.searchField = document.querySelector(SELECTOR.SEARCH_FIELD) as HTMLInputElement;
    this.searchForm = document.querySelector(SELECTOR.SEARCH_FORM) as HTMLFormElement;
  }

  init() {
    this.suggestLayer = document.querySelector(SELECTOR.LAYER) as HTMLDivElement;
    this.searchField = document.querySelector(SELECTOR.SEARCH_FIELD) as HTMLInputElement;
    this.searchForm = document.querySelector(SELECTOR.SEARCH_FORM) as HTMLFormElement;
  }

  show() {
    trackEmptyState.mark();
    this.retrieveEmptyState()
      .then(this.render.bind(this))
      .then(() => {
        window.o_squirrel.searchSuggest.setSuggest(-1);
      })
      .then(window.o_squirrel.searchSuggest.showLayer)
      .then(window.o_squirrel.searchSuggest.scrollToSearchField)
      .catch(window.o_squirrel.searchSuggest.handleError);
  }

  private renderKeywordTemplate(suggestions: SuggestResponse): string {
    const keywords =
      window.o_squirrel.submitHistory.retrieveViewedSearch().length > 0
        ? suggestions.keywords.slice(0, 5)
        : suggestions.keywords;
    return Mustache.render(keywordsTemplate, {
      original: suggestions.original,
      keywords,
      suggestPos: suggestions.suggestPos,
    });
  }

  render(results: [SuggestResponse | Error, string]) {
    const suggestions: SuggestResponse = results[0] as SuggestResponse;
    const template: string = results[1];
    const historyTemplate: string = this.renderHistoryTemplate();

    const renderedTemplate = Mustache.render(
      template,
      {},
      {
        headlineTemplate,
        historyTemplate,
        keywordTemplate: this.renderKeywordTemplate(suggestions),
      }
    );
    performance.measure(MARK.SUGGEST_RENDER_TIME, MARK.SUGGEST_RENDER_TIME_START);
    this.suggestLayer.innerHTML = renderedTemplate;
  }

  retrieveEmptyState(): Promise<[SuggestResponse | Error, string]> {
    return Promise.all([
      window.o_squirrel.searchSuggest
        .fetchSuggestions("", 0)
        .then(window.o_squirrel.searchSuggest.extractSuggestions)
        .then(window.o_squirrel.searchSuggest.updateSearchFieldTarget),
      Promise.resolve(templateString),
    ]);
  }

  private renderHistoryTemplate() {
    if (isCookieBannerEnabled() && !window.o_squirrel.submitHistory.isEmpty()) {
      const response: HistorySearchItem[] = window.o_squirrel.submitHistory.retrieveViewedSearch().slice().reverse();
      return window.o_squirrel.searchHistory.renderHistory(response);
    } else {
      return "";
    }
  }
}

const instance = new EmptyStateSuggest();
export const emptyStateSuggest = {
  init: instance.init.bind(instance),
  show: instance.show.bind(instance),
};
